import Axios, { AxiosError, type AxiosRequestConfig } from 'axios';
import { LOCAL_STORAGE_KEYS } from '@/lib/constants';

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: BASE_URL,
});

export const fetcher = <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
  const paramsString = window.location.search;
  const searchParams = new URLSearchParams(paramsString);
  let token = searchParams.get('token') || null;
  if (!token) {
    token = localStorage.getItem(LOCAL_STORAGE_KEYS.ackPaperworkToken);
  } else if (token) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.ackPaperworkToken, token);
  }
  const updatedHeaders = {
    ...config.headers,
    'Content-Type': 'application/json',
    'X-Client-Environment': import.meta.env.VITE_ENVIRONMENT || '',
    'X-Client-Stage': import.meta.env.VITE_STAGE || '',
    'X-Client-Release-Version': import.meta.env.VITE_RELEASE_VERSION || '',
    'X-Client-Released-At': import.meta.env.VITE_RELEASED_AT || '',
    'X-Auth-Client': 'PAPERWORK',
    Authorization: `Bearer ${token || ''}`,
  };
  const promise = AXIOS_INSTANCE({
    ...config,
    headers: updatedHeaders,
    ...options,
    withCredentials: true,
  }).then(({ data }) => data);
  return promise;
};
// Override the return error type for react-query and swr
export type ErrorType<Error> = AxiosError<Error>;

interface ApiErrorBody {
  message?: string;
}

/** The message the API sent with a failed response, else the error's own, else the fallback. */
export const getApiErrorMessage = (error: unknown, fallback: string) => {
  if (Axios.isAxiosError<ApiErrorBody>(error)) {
    return error.response?.data?.message || error.message || fallback;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
};
// Standard body type
export type BodyType<BodyData> = BodyData;
